<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 系统设置 / 等级配置</span>
      </div>
    </div>
<!--    <div style="overflow:hidden; padding:0 15px;">-->
<!--      <div @click="addAdmin" class="addBtn">+ 添加等级</div>-->
<!--    </div>-->
    <div style="padding: 10px 15px">
      <div>
        <table width="100%">
          <tr>
            <th class="th">
              等级编号
            </th>
            <th class="th">
              等级名称
            </th>
            <th class="th">
              加息率
            </th>
            <th class="th">
              累计投资额
            </th>
            <th class="th">
              提现手续费
            </th>
            <th class="th">
              现金红包
            </th>
            <th class="th">
              奖品
            </th>
            <th class="th">
              操作
            </th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td">
              {{ value.levelId }}
            </td>
            <td class="td">
              {{ value.levelName }}
            </td>
            <td class="td">
              {{ value.levelRateHike }}
            </td>
            <td class="td">
              {{ value.levelCumulativeInvestmentAmount }}
            </td>
            <td class="td">
              {{ value.levelWithNum }}%
            </td>
            <td class="td">
              {{ value.levelPrice }}元
            </td>
            <td class="td">
              {{ value.levelAward }}
            </td>
            <td class="td">
              <div style="overflow: hidden">
                <div @click="updateAdmin(value)" style="cursor: pointer; float: left; color: #1890ff">
                  <img src="@/assets/home/update.png" style="height: 18px; vertical-align: middle" />
                  修改
                </div>
<!--                <div @click="deleteAdmin(value.levelId)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">-->
<!--                  <img src="@/assets/home/delete.png" style="height: 16px; vertical-align: middle" />-->
<!--                  删除-->
<!--                </div>-->
              </div>
            </td>
          </tr>
        </table>
      </div>

    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "LevelList",
  data(){
    return{
      adminList:[],
      page:1,
      num:20,
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
  },
  methods: {
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",JSON.stringify(obj))
      this.$emit("send",'updateLevel')
    },
    deleteAdmin(id){
      if(confirm("确认删除此等级吗？")){
        let that=this
        loading("加载中")
        axiosPost(DO_NET_URL+"api/DeleteLevel?id="+id,"",function (res){
          console.log(res.data)
          closeLoading()
          if(res.code==200){
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    addAdmin(){
      this.$emit("send",'addLevel')
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      axiosGet(DO_NET_URL+"api/GetLevel",function (res){
        console.log(res.data)
        closeLoading()
        that.adminList=res.data
      })
    },
  }
}
</script>

<style scoped>
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>